import { render, staticRenderFns } from "./shopsAccountTable.vue?vue&type=template&id=33e4e6ec"
import script from "./shopsAccountTable.vue?vue&type=script&lang=js"
export * from "./shopsAccountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports